import ProjectPageSections from 'features/ProjectPage'

const ProjectPage = () => {
  return (
    <ProjectPageSections />
  )
}

export default ProjectPage